import { Wiki } from "./wiki";
export default Wiki;
